// After a page change, bring the table's first row back into view: reset the
// rows area's own scroll, and if the page has been scrolled past the table's
// top, scroll only the nearest scrolling parent back up to it
// (scrollIntoView would also move the app layout around it).
export const scrollToTableTop = (tableEl, rowsEl) => {
    if (rowsEl) rowsEl.scrollTop = 0;
    let parent = tableEl?.parentElement;
    while (parent && parent !== document.body) {
        const { overflowY } = window.getComputedStyle(parent);
        if (overflowY === 'auto' || overflowY === 'scroll') break;
        parent = parent.parentElement;
    }
    if (!tableEl || !parent || parent === document.body) return;
    const delta = tableEl.getBoundingClientRect().top - parent.getBoundingClientRect().top;
    if (delta < 0) parent.scrollTop += delta;
};
